import { Box, styled, Typography, TypographyProps } from "@mui/material";

import { Column } from "@rui/Stack";

export const MarkerDot = styled(Box)(({ theme }) => ({
  height: "13px",
  width: "13px",
  borderRadius: "50%",
  border: `3px solid ${theme.palette.shades.primary[500]}`,
  backgroundColor: "#FFF",
}));

export const MarkerLabelLine = styled(Box)(({ theme }) => ({
  height: "8px",
  width: "1px",
  border: `solid 1.5px ${theme.palette.shades.primary[500]}`,
  borderRadius: "1.5px",
}));

const MarkerLabelText = styled((props: TypographyProps) => (
  <Typography variant="bodySecondaryMed" {...props} />
))(({ theme }) => ({
  lineHeight: 1,
  color: theme.palette.shades.primary[500],
}));

type MarkerProps = { label?: string | number; value: number };

const Marker = styled(({ label, value: _, ...props }: MarkerProps) => (
  <Column variant="center" {...props}>
    {label && (
      <Column variant="center" sx={{ transform: "translateY(2px)" }}>
        <MarkerLabelText>{label}</MarkerLabelText>
        <MarkerLabelLine />
      </Column>
    )}
    <MarkerDot sx={{ height: "16px", width: "16px" }} />
  </Column>
))(({ label, value }) => ({
  left: `${value}%`,
  position: "absolute",
  top: label ? -25 : -3,
  transform: "translateX(-50%)",
}));

export default Marker;
